module.exports = __webpack_public_path__ + "media/images/flags/4x3/lie-249e148d1c5f7093bbe938aa689309cf.svg";